import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import celebrate from '../../../assets/kitoBuddy/celebration-2.svg';
import AdventureCard from '../../../components/AdventureCard';
import CustomButton from '../../../components/Inputs/CustomButton';
import '../firstaid.css';

export default function Correct({
  setStep,
  setChoice,
  answeredQuestion,
  setAnsweredQuestion,
  totalSteps = 7,
}) {
  const { t } = useTranslation();

  const triggerNextStep = () => {
    setAnsweredQuestion(null);

    setStep((prevStep) => {
      const isLastStep = prevStep === totalSteps;
      setChoice(isLastStep ? 'Finish' : '');
      return isLastStep ? 1 : prevStep + 1;
    });
  };

  return (
    <div className="wrong__container">
      <div className="header">
        <img src={celebrate} alt="Celebrate" className="correct__banner" />
        <div />
        <AdventureCard correctAnswer text={t(answeredQuestion)} />
      </div>
      <div className="buttons__container">
        <CustomButton
          className="button__next"
          label={t('staticPages.firstAidChild.nextButton')}
          onClick={triggerNextStep}
        />
      </div>
    </div>
  );
}

Correct.defaultProps = {
  answeredQuestion: null,
};

Correct.propTypes = {
  setStep: PropTypes.func.isRequired,
  setChoice: PropTypes.func.isRequired,
  answeredQuestion: PropTypes.string,
  setAnsweredQuestion: PropTypes.func.isRequired,
};
